/** Backend returns this when PATCH targets a project that is no longer NEW. */
export const CREATOR_PROJECT_LOCKED_MESSAGE = 'Nie można edytować tego projektu';

/** Backend returns this when submit-quote targets a non-NEW / already submitted project. */
export const CREATOR_PROJECT_SUBMIT_LOCKED_MESSAGE = 'Nie można wysłać projektu do wyceny';

type ApiLikeError = {
	status?: number;
	stack?: string[];
};

const readStack = (error: unknown): string[] => {
	const stack = (error as ApiLikeError)?.stack;
	return Array.isArray(stack) ? stack : [];
};

export const isCreatorProjectLockedError = (error: unknown): boolean => {
	const status = (error as ApiLikeError)?.status;
	if (status !== 400) return false;
	const stack = readStack(error);
	return (
		stack.includes(CREATOR_PROJECT_LOCKED_MESSAGE) ||
		stack.includes(CREATOR_PROJECT_SUBMIT_LOCKED_MESSAGE)
	);
};
